
/**
 * ProseCleaner.js
 * Hides empty Word-generated tags inside .prose (or .rte)
 * Safe for Shopify OS 2.0 themes — runs on DOM ready & section reloads
 */

(function () {
  const isVisiblyEmpty = (el) => {
    const clone = el.cloneNode(true);
    clone.querySelectorAll('br, b, i, strong, em, span').forEach(e => {
      if (!e.textContent.replace(/\u00A0/g, '').trim()) e.remove();
    });
    return !clone.textContent.replace(/\u00A0/g, '').trim();
  };

  const cleanProse = (root) => {
    if (!root) return;

    // Hide empty <a><span> </span></a>
    root.querySelectorAll('a').forEach(a => {
      if (isVisiblyEmpty(a)) a.style.setProperty('display', 'none', 'important');
    });

    // Hide empty <p> (<p><b><br></b></p>, <p><br></p>, etc.)
    root.querySelectorAll('p').forEach(p => {
      if (isVisiblyEmpty(p)) p.style.setProperty('display', 'none', 'important');
    });

    // Hide empty <span>
    root.querySelectorAll('span').forEach(span => {
      if (isVisiblyEmpty(span)) span.style.setProperty('display', 'none', 'important');
    });

    console.log('%c[ProseCleaner]%c hidden empty tags', 'color:#4FB2BF;font-weight:bold;', 'color:#999');
  };

  const watchForProse = () => {
    const proseBlocks = document.querySelectorAll('.prose, .rte');
    if (proseBlocks.length) proseBlocks.forEach(cleanProse);
    return proseBlocks.length > 0;
  };

  // Initial run
  document.addEventListener('DOMContentLoaded', () => {
    if (!watchForProse()) {
      // Wait until prose exists (in case it's loaded dynamically)
      const observer = new MutationObserver(() => {
        if (watchForProse()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  });

  // Re-run when Shopify re-renders a section in Theme Editor
  document.addEventListener('shopify:section:load', () => {
    watchForProse();
  });
})();